import React from 'react';

/**
 * Écran de chargement aux couleurs de HubImmo : logo qui s'écrit lettre par lettre, point orange qui pulse,
 * sans texte ni barre (seul le nom animé). Styles dans index.html (classes hb-boot), communs avec l'écran affiché avant le
 * téléchargement de l'application : l'animation y continue sans repartir de zéro (décalage --hb-elapsed).
 * inline : dans une page déjà affichée (contenu d'un onglet) plutôt qu'en plein écran.
 * replay : rejoue l'animation complète (connexion), au lieu de reprendre celle du premier écran.
 * Le nom se réécrit à chaque chargement (onglet, liste…) pour qu'on le retienne.
 */
const LETTERS = [['H', 'hub'], ['u', 'hub'], ['b', 'hub'], ['i', 'immo'], ['m', 'immo'], ['m', 'immo'], ['o', 'immo'], ['.', 'dot']];

/** Durée minimale d'affichage : le nom s'écrit en entier puis reste un instant à l'écran (ni trop long, ni trop court). */
export const BRAND_INTRO_MS = 2600;

/** Attend que l'animation lancée à `since` (ms) soit allée au bout ; immédiat si c'est déjà le cas. */
export const waitBrandIntro = (since = Date.now()) => new Promise((resolve) => {
  setTimeout(resolve, Math.max(0, BRAND_INTRO_MS - (Date.now() - (since || 0))));
});

const BrandLoader = ({ inline = false, replay = false }) => {
  const bootAt = typeof window !== 'undefined' ? window.__hubBootAt : null;
  // Reprend l'animation du premier écran si elle est en cours ; sinon le nom se réécrit (à chaque chargement)
  const since = bootAt ? Date.now() - bootAt : 0;
  const elapsed = !replay && since < BRAND_INTRO_MS ? since : 0;
  const settled = false;
  return (
    <div className={`hb-boot${settled ? ' hb-boot--settled' : ''}${inline ? ' hb-boot--inline' : ''}`}
      style={settled || !elapsed ? undefined : { '--hb-elapsed': `-${elapsed}ms` }} role="status" aria-label="Chargement de HubImmo">
      <div className="hb-boot-word" aria-hidden="true">
        {LETTERS.map(([ch, kind], i) => <span key={i} className={`hb-${kind}`} style={{ '--i': i }}>{ch}</span>)}
      </div>
    </div>
  );
};

export default BrandLoader;
